/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { type PropsWithChildren } from 'react';
import { css, jsx } from '@compiled/react';
import { fg } from '@atlassian/jira-feature-gating';

export const ActionContainer = ({ children }: PropsWithChildren<{}>) => {
	return (
		<div
			data-testid="native-issue-table.common.ui.issue-cells.issue-summary.action-container"
			css={[
				// eslint-disable-next-line no-nested-ternary
				fg('jira_list_merged_column_gate')
					? fg('jira_list_merged_column_inline_create_icon_style')
						? containerStylesNew
						: containerStyles
					: containerStylesOld,
			]}
		>
			{children}
		</div>
	);
};

const containerStylesNew = css({
	display: 'flex',
	flexGrow: 1,
	minHeight: '100%',
	'--open-button-display': 'none',
	'--action-button-display': 'none',
	'&:hover': {
		'--open-button-display': 'flex',
		'--action-button-display': 'flex',
	},
	'&:focus-within': {
		'--open-button-display': 'flex',
		'--action-button-display': 'flex',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'& > div': {
		justifyContent: 'space-between',
	},
});

const containerStyles = css({
	display: 'flex',
	flexGrow: 1,
	minHeight: '100%',
	'--open-button-display': 'none',
	'--action-button-opacity': 0,
	'&:hover': {
		'--open-button-display': 'flex',
		'--action-button-opacity': 1,
		'--open-button-opacity': 1,
	},
	'&:focus-within': {
		'--open-button-display': 'flex',
		'--action-button-opacity': 1,
		'--open-button-opacity': 1,
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'& > div': {
		justifyContent: 'space-between',
	},
});

/**
 * @deprecated remove when jira_list_merged_column_gate is removed
 */
const containerStylesOld = css({
	display: 'flex',
	flexGrow: 1,
	minHeight: '100%',
	'--open-button-opacity': 0,
	'&:hover': {
		'--open-button-opacity': 1,
	},
	'&:focus-within': {
		'--open-button-opacity': 1,
	},
});
